import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchDocumentTypeUseComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getAllDocumentTypeUse from '../../services/documentTypeUse/getAllDocumentTypeUse'

export function * fetchDocumentTypeUse () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const documentTypeUse = yield call(getAllDocumentTypeUse, auth.token)
    yield put(fetchDocumentTypeUseComboSuccess(documentTypeUse))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchDocumentTypeUse () {
  yield takeLatest(combosActionTypes.FETCH_DOCUMENT_TYPE_USE, fetchDocumentTypeUse)
}
